var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickonBoardPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C27.86 8 34 10.8 34 18.3C34 22.62 30.56 27.64 24 32.94C17.44 27.64 14 22.6 14 18.3C14 10.8 20.14 8 24 8ZM24 4C17.46 4 10 8.92 10 18.3C10 24.54 14.66 31.12 24 38C33.34 31.12 38 24.54 38 18.3C38 8.92 30.54 4 24 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C21.8 14 20 15.8 20 18C20 20.2 21.8 22 24 22C25.0609 22 26.0783 21.5786 26.8284 20.8284C27.5786 20.0783 28 19.0609 28 18C28 16.9391 27.5786 15.9217 26.8284 15.1716C26.0783 14.4214 25.0609 14 24 14ZM10 40H38V44H10V40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickonBoardPinIcon);
export default __webpack_public_path__ + "static/media/quickonBoardPinIcon.0d9a691a6ff24c9608a09f933e3591e8.svg";
export { ForwardRef as ReactComponent };